import React from 'react'
import Text from '../../../../Text'
import SpecsTable from '../../Utils/ItemSpecifications/SpecsTable'
import styles from './styles.module.css'

/**
 * Full-width product detail block rendered BELOW the gallery: the whole
 * description plus every spec row, with nothing clamped and nothing collapsed.
 *
 * The right-hand column shows the same copy behind a 4-line clamp ("Continue
 * reading") and a collapsed "Specifications" section, which is right for a short
 * accessory but buries a full spec sheet behind two clicks. Products that carry
 * one opt in per catalog doc with `detailsUnderGallery: true`, so this changes
 * nothing for the rest of the shop.
 *
 * Reads `description`/`specs` off the joined offer, exactly like the sibling
 * Description/ItemSpecifications do — both arrive with the client offers refetch
 * rather than the grid-capped SSR payload, so this renders null until they land.
 *
 * `detailsUnderGallery` is a CATALOG field (dataset.ndjson), not a backend one:
 * the offer merge lets a catalog key that is present win, so the flag needs no
 * backend support and no entry in the SSR projection list.
 */
function DetailsUnderGallery({ item }) {
  if (!item || !item.detailsUnderGallery) {
    return null
  }

  const description = item.fullSetDescription || item.description
  const specsByCategory = (item.specs && item.specs.specsByCategory) || null

  if (!description && !specsByCategory) {
    return null
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.heading}>
        <Text type="heading-4">More information</Text>
      </div>
      <div className={styles.content}>
        {description && (
          <div className={styles.description}>
            {description
              .split('\n')
              .filter((d) => !!d)
              .map((d, i) => (
                // `large` (20px) rather than `regular` (16px): this is the page's
                // primary copy now, not the clamped teaser in the buy column.
                <Text type="large" key={'details-description-' + i}>
                  {d}
                </Text>
              ))}
          </div>
        )}

        {specsByCategory &&
          Object.keys(specsByCategory).map((category) => (
            <div className={styles.specs} key={category}>
              <div className={styles.specsTitle}>
                <Text type="heading-8">{category}</Text>
              </div>
              <SpecsTable specs={specsByCategory[category]} theme={'light'} />
            </div>
          ))}
      </div>
    </div>
  )
}

export default DetailsUnderGallery
